"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatus = void 0;
var UserStatus;
(function (UserStatus) {
    UserStatus["New"] = "New";
    UserStatus["Activated"] = "Activated";
    UserStatus["Disabled"] = "Disabled";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
//# sourceMappingURL=user-status.js.map